import { device } from 'constants/responsive'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled, { css } from 'styled-components'

type Sizes = { small?: boolean; big?: boolean; huge?: boolean }

export const Wrapper = styled(InfiniteScroll)<{ grid: boolean } & Sizes>`
  overflow: visible !important;
  position: relative;

  padding-bottom: 45px;
  ${({ grid, small, big, huge }) =>
    grid &&
    css`
      display: grid;
      grid-template-columns: repeat(auto-fill, ${small ? '100px' : big ? '178px' : huge ? '250px' : '130px'});
      grid-template-rows: 1fr;
      grid-column-gap: 14px;
      grid-row-gap: 28px;

      @media ${device.laptopL} {
        grid-template-columns: repeat(4, 1fr);
      }

      @media ${device.laptop} {
        grid-template-columns: repeat(3, 1fr);
      }

      @media ${device.tablet} {
        grid-template-columns: repeat(2, 1fr);
      }
    `}
`

export const LoaderWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  justify-content: center;
`
